<template>
    <div class='t_content_view'>
        <el-page-header @back="goBack" content="手机号添加好友" style="margin-bottom: 20px;" />
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>功能说明</div>
        </div>
        <div class="t_gn_font" style="margin-top: 20px;">1.系统根据选中的扫码号，搜寻手机号对应的个人微信号，并自动加好友；</div>
        <div  class="t_gn_font">2.若用户将手机号码添加方式关闭，则无法添加成功；</div>
        <div  class="t_gn_font">3.扫码号三天内不会对同一个手机号重复发起申请。</div>
        <!-- line -->
        <div class="t_line"></div>
        <!-- 标题 --> 
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>基础设置</div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>任务名称：</div>
            <div>
                <el-input v-model="taskname" maxlength="20" style="width: 600px;"  placeholder="请输入任务名称，最多20个字"  clearable />
            </div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>选择扫码号：</div>
            <div>
                <!-- <el-select  multiple v-model="userids.data" placeholder="选择扫码号">
                    <el-option style="height: auto;line-height: normal;padding:8px 32px 8px 20px" v-for="(item,index) in allpeolist.data" 
                    :key="index"
                    :value="item.id" :label="item.name" >
                    </el-option>
                </el-select> -->
                <el-cascader
                    v-model="selectedPath.data"
                    :options="allcomppeolist.data"
                    :props="{ expandTrigger: 'hover',multiple: true }"
                    placeholder="请选择成员"
                    clearable
                    @change="handleChange"
                    />
                <div style="font-size: 13px;color: #777777;margin-top: 10px;">
                    扫码号将对手机号码按顺序平均添加，每个扫码号每日添加好友数量受微信限制，建议根据业务实际情况选择扫码号数量
                </div>
            </div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>添加手机号：</div>
            <div>
                <!-- <div style="margin-bottom: 15px;"> -->
                    <!-- <el-checkbox :disabled="route.query.type=='bj'" @change="contypebtn(1)" v-model="checked1" label="填写手机号"  />
                    <el-checkbox :disabled="route.query.type=='bj'" @change="contypebtn(2)" v-model="checked2" label="导入手机号"  />
                    <el-checkbox :disabled="route.query.type=='bj'" @change="contypebtn(3)" v-model="checked3" label="选择敢探号人群"  /> -->
                    <!-- <el-checkbox :disabled="route.query.type=='bj'" @change="contypebtn(5)" v-model="checked5" label="实时任务"  /> -->
                <!-- </div> -->
                
                <!-- <div  v-if="checked1">
                    <el-input
                        :disabled="route.query.type=='bj'"
                        class="t_wr_phone"
                        v-model="writephone"
                        :rows="10"
                        type="textarea"
                        placeholder="请粘贴需添加的手机号，多个手机号使用回车作为分隔符（单次最多添加1000个手机号）"
                     clearable />
                </div> -->
                <!-- <div  v-if="checked2" style="display:flex;">
                    <el-button :disabled="route.query.type=='bj'" @click="downloadExcel" :icon="Download" type="primary">下载模板</el-button>
                    <el-button @click="getxslx" type="primary">导入模板</el-button>
                    <div style="font-size: 15px; margin-left: 10px;color:#67C23A" v-if="excelfile">已上传</div>
                  
                    
                </div>  -->
                <!-- <div v-if="checked3" >
                    <div style="display:flex;" >
                        <el-input size="small"
                        :disabled="route.query.type=='bj'"
                         v-model="gthinput" placeholder="请输入搜索内容" style="margin-right: 10px;width: 230px;"  clearable />
                        <el-button :disabled="route.query.type=='bj'" @click="searchgth" size="small" >检索</el-button>
                    </div>
                    <div class="t_gth_list" v-for="(item,index) in gthfriend.data" :key="index">
                        <div >
                            <div style="display: flex;justify-content: space-between;align-items: center;width: 500px;">
                                <div>
                                    <el-tag
                                    size="small"    
                                    effect="dark">{{ item.type }}</el-tag>
                                    <span style="font-size: 15px;margin-left: 10px;">{{ item.title }}</span>
                                </div>
                                <div style="font-size: 15px;">数量：{{ item.user_amount }}</div>
                            </div>
                            <div style="font-size: 15px;color: #B0B0B0;margin-top: 5px;">{{ item.remark }}</div>
                        </div>
                        <div>
                            <div v-if="item.ischoose" >已选择</div>
                            <el-button v-if="!item.ischoose" @click="choosegthbtn(item)" size="small" type="primary" plain>选择</el-button>
                        </div>
                    </div>
                    <el-pagination
                        v-if="gthfriend.data.length>0"
                        style="margin-top: 20px;"
                        small
                        background
                        layout="prev, pager, next"
                        :total="gthtotal"
                        :current-page="nowpage"
                        @current-change="changegthpage"
                    />
                </div> -->
                <div  >
                    <div style="display:flex;" >
                        <el-input size="small" :disabled="route.query.type=='bj'" v-model="gthinput" placeholder="请输入搜索内容" style="margin-right: 10px;width: 230px;"  clearable />
                        <el-button @click="searchgth" size="small" :disabled="route.query.type=='bj'" >检索</el-button>
                    </div>
                    <div class="t_gth_list" v-for="(item,index) in gthfriend.data" :key="index">
                        <div >
                            <div style="display: flex;justify-content: space-between;align-items: center;width: 500px;">
                                <div>
                                    <el-tag
                                    size="small"    
                                    effect="dark">{{ item.type }}</el-tag>
                                    <span style="font-size: 15px;margin-left: 10px;">{{ item.title }}</span>
                                </div>
                                <div style="font-size: 15px;">数量：{{ item.user_amount }}</div>
                            </div>
                            <div style="font-size: 15px;color: #B0B0B0;margin-top: 5px;">{{ item.remark }}</div>
                        </div>
                        <div>
                            <div v-if="item.ischoose" >已选择</div>
                            <el-button v-if="!item.ischoose" @click="choosegthbtn(item)" size="small" type="primary" plain>选择</el-button>
                        </div>
                    </div>
                    <el-pagination
                        v-if="gthfriend.data.length>0"
                        style="margin-top: 20px;"
                        small
                        background
                        layout="prev, pager, next"
                        :total="gthtotal"
                        :current-page="nowpage"
                        @current-change="changegthpage"
                    />
                </div>
            </div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f">好友去重：</div>
            <div>
                <el-switch
                    v-model="repfriend"
                    style="--el-switch-on-color: #4F46E5"
                    :disabled="route.query.type=='bj'"
                />
                <div class="t_gn_font" >1.开启后，若该客户为同个企业内任一成员好友，则自动跳过添加该客户</div>
                <div  class="t_gn_font">2.开启后企业三天内不会对同一个手机号发起申请</div>
                <div  class="t_gn_font">3.需要客户绑定手机号才能生效，若未绑定手机号，仍会发起申请</div>
            </div>
        </div>
        <!-- line -->
        <div class="t_line"></div>
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>评论设置</div>
        </div>
        <!-- <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>加好友时间：</div>
            <div>
                <div>
                <el-checkbox :disabled="route.query.type=='bj'" @change="nowsendchange" v-model="nowsend" label="立即发送" size="large" />
                </div>
                <div>
                <el-checkbox :disabled="route.query.type=='bj'" @change="timesendchange" 
                style="margin-right: 20px;" v-model="timesend" label="定时发送" size="large" />
                <el-date-picker
                    :disabled="route.query.type=='bj'"  
                    class="t_choosetime"
                    v-model="sendtime"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetime"
                    placeholder="请选择时间"
                />
                </div>
            </div>
        </div> -->
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>验证信息：</div>
            <div>
                <checkmsg @choosecheckmsg = 'choosecheckmsg' :copyyzy="copyyzy" />
                <div style="font-size: 13px;color: #777777;margin-top: 10px;">
                    1.建议添加多组验证语，系统将随机发送，降低发送相同内容的风险，提高添加好友通过率
                </div>
                <div style="font-size: 13px;color: #777777;margin-top: 10px;">
                    2.引用验证语直接覆盖当前已编辑的内容
                </div>
            </div>
        </div>
        <!-- line -->
        <div class="t_line"></div>
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>添加成功后设置</div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f">企业标签：</div>
            <div>
                <chooseTag
                v-if="!checked3"  
                :choosedtag="choosedtag" 
                :bqData="bqData"
                :copybq="copybq" 
                @changechoosedtag="changechoosedtag"
                @changebqData = 'changebqData' />
                <div v-else>不可用，将使用敢探号标签覆盖</div>
                <div class="t_gn_font">添加完好友后，自动给好友打上企业标签</div>
            </div>
            
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f">好友欢迎语：</div>
            <div>
                <el-button @click="openhy" type="primary" color="#4F46E5">选择欢迎语</el-button>
                <div class="t_gn_font" style="color:black" v-show="nowhyy.data[0].title!=''">
                    当前欢迎语：
                    {{ nowhyy.data[0].title }}
                </div>
                <div class="t_gn_font">添加好友欢迎语后，当好友通过申请，将自动向好友发送欢迎语</div>
                <div class="t_gn_font">注1：每个扫码号仅能生效1种欢迎语，也可以在<span style="color: #4F46E5;">扫码号->好友欢迎语</span>中管理和创建欢迎语规则</div>
                <div class="t_gn_font">注2：若扫码号后续设置关联了其他欢迎语，则此处关联的欢迎语将会失效</div>
            </div>
            
        </div>
        <div class="t_con_box_f">
            <el-button v-if="route.query.type=='bj'" color="#4F46E5" @click="submit" style="margin-left:150px" type="primary">确认修改</el-button>
            <el-button v-else color="#4F46E5" @click="submit" style="margin-left:150px" type="primary">立即添加</el-button>
        </div>
    </div>
    <friendwelcomelist :copyhyy="copyhyy"  v-if="islistshow" :islistshow="islistshow" @chooselist = 'chooselist' />
</template>

<script setup>


import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Download,Upload } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { bqlist,getphoneexcel,addfriendphone,frienddetail ,getgthlist,newgetpeo,newaddfriend,newgetgth,newfriendadddetail,newgetgthlist,newgettaglist,newgetcomppeo} from '@/assets/js/common.js'
import chooseTag from '../components/chooseTag.vue';
import friendwelcomelist from '../components/phonefriendadd/cfriendwelcome.vue';
import checkmsg from '../components/phonefriendadd/checkmsg.vue';

import * as XLSX from 'xlsx';//引入写法

//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
const _urlnew = inject('_urlnew')
const goBack = () => {
    router.push({ path: '/navtkyl/phonefriendgth' })
}
onMounted(() => {
    console.log('onMounted')
    getallpeolist()
    //获取标签列表
    getbqlist()
    if(route.query.id){
        getlist()
    }
    //获取主体+成员
    getcomppeolist()
})
//复制的验证语列表
const copyyzy = reactive({
    data:[]
})
//复制的标签
// const copybq = reactive({
//     data:[]
// })
//获取详情数据
const getlist = ()=>{
    newfriendadddetail({id:route.query.id}).then((response)=>{
        console.log('详情数据')
        console.log(response.data)
        //赋值数据
        //群发标题
        taskname.value = response.data.data.task_name
        //选择成员
        var userListid = []
        for(var x = 0;x<response.data.data.add_by.length;x++){
            userListid.push(response.data.data.add_by[x]*1)
        }
        userids.data = userListid
        //好友去重
        if(response.data.data.isRepeat==1){
            repfriend.value=true
        }else{
            repfriend.value=false
        }
        //验证语
        // copyyzy.data = response.data.data.varify_message
        // yzylist.data = response.data.data.varify_message

        var yzyarr = []
        for(var x = 0;x<response.data.data.varify_message.split(',').length;x++){
            yzyarr.push(
                {
                    title:'第'+x+'组',
                    name:x,
                    content:response.data.data.varify_message.split(',')[x]
                }
            )
        }
        yzylist.data = yzyarr
        //标签
        // if(response.data.data.tagList!=null){
        //     choosedtag.data = response.data.data.tagList
        //     changetagwindow(response.data.data.tagList)
        // }
        //欢迎语
        if(response.data.data.wel_id){
            nowhyy.data[0]=response.data.data.wel_id
            copyhyy.data.push(response.data.data.wel_id)
        }

        
        
        if(route.query.type=='bj'){
            if(response.data.data.add_type==1){
                //填写
                checked1.value=true
                checked2.value=false
                checked3.value=false
            }else if(response.data.data.add_type==2){
                //导入
                checked1.value=false
                checked2.value=true
                checked3.value=false
            }else if(response.data.data.add_type==3){
                //感叹号
                checked1.value=false
                checked2.value=false
                checked3.value=true
                choosegth.data.id = response.data.data.crowd_id
            }
            
        }
        
    })
}
//copy欢迎语
const copyhyy = reactive({
    data:[]
})
//copy标签弹窗显示
const changetagwindow = (arr)=>{
    for(var y=0;y<arr.length;y++){
        for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    if(bqData.data[i].tags[x].id==arr[y].id){
                        bqData.data[i].tags[x].checked=true
                    }
                    
                }
            }
    }
}
//群发标题
const taskname = ref('')
//选择成员
const userids = reactive({
  data:[]
})
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo().then((response)=>{
        if (response.data.msg.code == 0) {
             console.log('成员==')
             console.log(response.data)
            allpeolist.data = response.data.data
        }
    })
}
//选择内容种类
const checked1 = ref(true)
const checked2 = ref(false)
const checked3 = ref(false)
const contypebtn = (type)=>{
    if(type==1){
        checked1.value=true
        checked2.value=false
        checked3.value=false
    }else if(type==2){
        checked1.value=false
        checked2.value=true
        checked3.value=false
    }else if(type==3){
        checked1.value=false
        checked2.value=false
        checked3.value=true
    }
}
//填写手机号
const writephone = ref('')
//上传手机号
const excelfile = ref('')
const uploadok = (file)=>{
    excelfile.value = file.raw
}
//搜索敢探号
const gthinput = ref('')
//当前页嘛
const nowpage = ref(1)
//搜索总数
const gthtotal = ref(null)
const searchgth = ()=>{
    if(gthinput.value!=''){
        choosegth.data = {}
        newgetgthlist({title:gthinput.value,page:nowpage.value,page_size:20}).then((response)=>{
            console.log('搜索敢探号')
            console.log(response.data.data)
            gthfriend.data = response.data.data.data
            gthtotal.value = response.data.data.total
        })
    }else{
        ElMessage.error('请输入搜索内容')
    }
    

}
//感叹号分页
const changegthpage = (val)=>{
    console.log(val)
    nowpage.value = val
    searchgth()
}
//感叹号好友列表
const gthfriend = reactive({
    data:[]
})
//选择的感叹号列表
const choosegth = reactive({
    data:{}
})
//点击选择敢探号
const choosegthbtn = (item)=>{
    choosegth.data = item
    for(var x = 0;x<gthfriend.data.length;x++){
        if(gthfriend.data[x].id==item.id){
            gthfriend.data[x].ischoose=true
        }else{
            gthfriend.data[x].ischoose=false
        }
    }
}
//好友去重
const repfriend = ref(false)

//发送时间
//立即发送
const nowsend = ref(true)
//立即发送状态改变
const nowsendchange = (val)=>{
  if(val){
    timesend.value = false
    sendtime.value = ''
  }else{
    nowsend.value = true
  }
}
//定时发送
const timesend = ref(false)
//定时发送状态改变
const timesendchange = (val)=>{
  if(val){
    nowsend.value = false
  }else{
    timesend.value = true
  }
}
//发送时间
const sendtime = ref('')
//获取当前时间年月日时分秒
const getNowDate = ()=>{
    var date = new Date();
    var sign2 = ":";
    var year = date.getFullYear() // 年
    var month = date.getMonth() + 1; // 月
    var day = date.getDate(); // 日
    var hour = date.getHours(); // 时
    var minutes = date.getMinutes(); // 分
    var seconds = date.getSeconds() //秒
    var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
    var week = weekArr[date.getDay()];
    // 给一位数的数据前面加 "0"
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (day >= 0 && day <= 9) {
        day = "0" + day;
    }
    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    // console.log(year + "-" + month + "-" + day + " " + hour + sign2 + minutes )
    //返回格式2022-11-25 10:25:39
    
    return year + "-" + month + "-" + day + " " + hour + sign2 + minutes+ sign2 + seconds ;
}

//验证语
const yzylist = reactive({
    data:[]
})
const choosecheckmsg = (val)=>{
    console.log('yanzhegnyu-----')
    console.log(val)
    yzylist.data = val
}


//提交
const submit = ()=>{
   
    //标题
    if(taskname.value==''){
        ElMessage.error('请输入标题')
        return
    }
    var taskName = taskname.value
    //扫码号
    // if(userids.data.length==0){
    //     ElMessage.error('请选择扫码号')
    //     return
    // }
    if(selectedPath.data.length==0){
        ElMessage.error('请选择成员')
        return
    }
    var corp_members = []
    //讲二维数组[[1,2],[3,4]]转为一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]格式
    corp_members = selectedPath.data.map(item => ({
        corp_id: item[0],
        id: item[1]
    }))


    var userIds = userids.data.join(',')
    //敢探号id
    var gthId = ''   
    if(Object.keys(choosegth.data).length == 0){
        ElMessage.error('请选择敢探号人群')
        return
    }else{
        gthId = choosegth.data.id
    }

    //手机号方式
    // if(checked1.value){
    //     //填写
    //     var addType = 1
    // }else if(checked2.value){
    //     //导入
    //     var addType = 2
    // }else if(checked3.value){
    //     //感叹号
    //     var addType = 3
    // }
    // if(addType==1){
    //     if(writephone.value==''&&route.query.type!='bj'){
    //         ElMessage.error('请填写手机号')
    //         return
    //     }
    // }else if(addType==2){
    //     if(excelfile.value==''&&route.query.type!='bj'){
    //         ElMessage.error('请上传文件')
    //         return
    //     }
    // }else if(addType==3){
    //     if(Object.keys(choosegth.data).length == 0){
    //         ElMessage.error('请选择敢探号人群')
    //         return
    //     }else{
    //         gthId = choosegth.data.id
    //     }
    // }
   
    //导入手机号
    // if(excelfile.value!=''){
    //     var file = excelfile.value
    // }else{
    //     var file = ''
    // }
    
    //发送手机号
    // if(addType==1){
    //     var phones_before = writephone.value.split(/\n/)
        
    // }
    // if(addType==2){
    //     var phones_before = excelfile.value
        
    // }
    
    // for (let i in phones_before) {
    //         phones_before[i] = phones_before[i].trim()
    //     }
    
    // var phones = phones_before
    //好友去重
    if(repfriend.value){
        //去重
        var isRepeat = 1
    }else{
        //不去
        var isRepeat = 0
    }
    //判断是立即发送还是定时发送
    // if(nowsend.value){
    //     var taskTime = getNowDate()
    // }else{
    //     var taskTime = sendtime.value
    // }


    //验证语
    if(yzylist.data.length==0){
        ElMessage.error('请设置验证语')
            return
    }else{
        var messageList = []
        for(var x = 0;x<yzylist.data.length;x++){
            messageList.push(yzylist.data[x].content)
        }
    }

    console.log(yzylist.data)
    
    //选中的标签
    if(choosedtag.data.length==0){
        var tag = ''
    }else{
        //看是否是敢探号
        if(checked3.value){
            var tag = ''
        }else{
            var tags = choosedtag.data
            var tagid = []
            for(var y = 0;y<tags.length;y++){
                tagid.push(tags[y].id)
            }
            var tag = tagid.toString()
        }
    }
    
   
    //选中欢迎语
    if(nowhyy.data[0].title==''){
        var welId = ''
    }else{
        var welId = nowhyy.data[0].id
    }

    //整理需要的数据
    var para = {
        'task_name': taskName,
        'add_by': corp_members,
        // 'addType': addType,
        // 'mobiles': phones,
        'is_repeat': isRepeat,
        'varify_message': messageList,
        'label_ids': tag,
        'wel_id': welId,
        // 'taskTime':taskTime,
        'call_task_id':gthId
    }

    if(route.query.type=='bj'){
        para.id = route.query.id
    }

    console.log(para)
    newaddfriend(para).then((response)=>{
        console.log(response)
        if(response.data.msg.code==0){
            ElMessage({
                message: '操作成功',
                type: 'success',
            })
            router.push({ path: '/navtkyl/phonefriendgth' })
        }
        
    })

   
    // const json = JSON.stringify(para);
    // // 将 json 字符串转化为 Blob 对象
    // const blob = new Blob([json], {
    //     type: 'application/json',
    // });
    // let forms = new FormData()
    // forms.append('file', file)
    // forms.append('para', blob)

   
    // console.log('整理需要的数据')
    // for (var value of forms.values()) {
    //     console.log(value);
    // }
    // addfriendphone(_url2,forms).then((response)=>{
    //     console.log(response)
    //     if(response.data.msg.code==0){
    //         ElMessage({
    //             message: '操作成功',
    //             type: 'success',
    //         })
    //         router.push({ path: '/navtkyl/phonefriend' })
    //     }
        
    // })
}

//列表是否展示
const islistshow = ref(false)
//欢迎语展示
const nowhyy = reactive({
    data:[{
        title:''
    }]
})
//欢迎语返回值
const chooselist = (val)=>{
    console.log('欢迎语返回值')
    console.log(val)
    
    
    islistshow.value = false
    if(val.length){
        nowhyy.data = val
    }else{
        nowhyy.data = [{
            title:''
        }]
    }
    console.log(nowhyy.data)
}
//打开欢迎语
const openhy = ()=>{
    islistshow.value = true
}
//下载导入模板
const downloadExcel = ()=>{
    const a = document.createElement('a');
        a.setAttribute('download', '');
        a.setAttribute('href', location.origin+'/img/phonenum.xls');
        a.click();
        console.log(location.origin+'/img/phonenum.xls')
}




//导入表格获取数据
const getxslx = ()=>{
        let {utils, read} = XLSX; //解构
        let fileSelector = document.createElement('input');
        fileSelector.setAttribute('type', 'file');
        fileSelector.click();
 
        fileSelector.onchange = e => {
            let files = e.target.files; //文件信息
            let fileReader = new FileReader(); //创建读取器
            fileReader.readAsBinaryString(files[0]); //读取文件的内容为二进制
            // 读取完成
            fileReader.onload = event => {
                let data = event.target.result;
                let workbook = read(data, {type: 'binary'}); //读取工作簿
                let sheetName = workbook.SheetNames[0]; //取第一张表
                let worksheet = workbook.Sheets[sheetName];
                let jsonData = utils.sheet_to_json(worksheet, {header: 1}); //生成json表格内容
                let dataRows = jsonData.slice(1);
                let flatArray = dataRows.flat();
                console.log(flatArray);
                excelfile.value = flatArray
                //获取数据格式
                // [
                //   ['订单号*', '订单来源', '套餐名称*'],//表头
                //   ['时间=', '姓名=', '地址='],//数据
                //   ['时间=2', '姓名=2', '地址=2']//数据
                // ]
            }
        }
    }
//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})
//获取主体+成员下拉
const getcomppeolist = ()=>{
    newgetcomppeo().then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data.map(corp => {
                const hasDevices = corp.device && corp.device.length > 0;
                return {
                value: corp.corp_id,
                label: corp.corp_name,
                // 无设备时禁用该项并清空 children
                disabled: !hasDevices,
                children: hasDevices
                    ? corp.device.map(device => ({
                        value: device.id,
                        label: device.name,
                        // 可添加其他自定义属性，如在线状态图标等
                        // 此处保留原始设备对象以便扩展
                        rawDevice: device
                    }))
                    : []
                };
            });
           console.log('主体+成员')
            console.log(allcomppeolist.data)
        }
    })
}
//主体+成员下拉选中的数据
const selectedPath = reactive({
    data:[]
})
//联动数据，过滤数据，只能选一个一级多个二级
const handleChange = (val)=>{
    console.log(val)
    //只能选一个主体
    if(val && val.length > 0){
        // 获取所有一级节点值（父节点ID）
        const parentIds = val.map(item => item[0])
        // 去重获取所有唯一的父节点
        const uniqueParentIds = [...new Set(parentIds)]
        
        // 如果存在多个父节点，只保留最后一个选中的父节点及其子节点
        if(uniqueParentIds.length > 1){
            const lastParentId = uniqueParentIds[uniqueParentIds.length - 1]
            // 筛选出最后一个父节点的所有相关节点
            const newVal = val.filter(item => item[0] === lastParentId)
            // 延迟更新确保界面正确响应
            setTimeout(()=>{
                selectedPath.data = newVal
                console.log(selectedPath.data)
            }, 0)
        }
    }
    
}

//////////////////////////////////

//选择标签组件需要的数据

//选中的标签数组
const choosedtag = reactive({
    data:[]
})
//监听子组件传来的数据
const changechoosedtag = (e)=>{
    choosedtag.data = e
}
// 全部标签
const bqData = reactive({
    data:[]
})
//监听子组件传来的数据
const changebqData = (e)=>{
    bqData.data = e
}
//获取标签列表
const getbqlist = ()=>{
    newgettaglist().then((response)=>{
        console.log('标签')
        console.log(response)
        if (response.data.msg.code == 0) {
            bqData.data = response.data.data
            console.log('response.data.result')
            console.log(response.data.data)
            //添加是否选中状态
            for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    bqData.data[i].tags[x].checked=false
                }
            }
        }
    })
}
////////////////////////////////

</script>

<style scoped>
.t_line{
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
    margin-top: 30px;
    margin-bottom: 30px;
}
:deep( .el-input__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .t_textarea_nobod .el-textarea__inner ){
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
.t_web_con{
    width: 400px;
    border: 1px solid #4F46E5;
    border-radius: 5px;
  }
  :deep(.t_web_con .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    background-color: #F1F3F9;
    resize: none;
  }
  .t_emoji_img{
    width: 20px;
    margin-left: 20px;
    margin-top: 5px;
    cursor: pointer;
  }
  :deep(.t_speak_input .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    /* background-color: #F1F3F9; */
    resize: none;
  }
  .avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  :deep( .avatar-uploader .el-upload ){
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep( .avatar-uploader .el-upload:hover) {
  border-color: var(--el-color-primary);
}

:deep( .el-icon.avatar-uploader-icon) {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.t_gn_font{
    font-size: 15px;
    color: #646464;
    margin-top: 5px;
}
:deep(.t_wr_phone .el-textarea__inner){
    width: 600px;
    border: 1px solid #4F46E5;
    box-shadow: 0 0 0 0px;
    background-color: #F1F3F9;
    resize: none;
  }
  :deep(.t_textarea_nobod .el-textarea__inner) {
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
.t_gth_list{
    display: flex;
    background: #f0f9fe;
    padding: 6px 30px 6px 15px;
    width: 640px;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}
</style>